import styled from "styled-components";

export const SideMenu = styled.section`
  width: 100vw;
  display: flex;
  min-height: calc(100vh - 128px);
  background: ${(props) => props.theme.colors.white100};
  flex-direction: column;
`;

export const SideMenuVersion = styled.p`
  color: ${(props) => props.theme.colors.black30};
  height: 72px;
  display: flex;
  padding: 0 36px 36px;
  font-size: 1.4rem;
  background: ${(props) => props.theme.colors.mainBg};
  align-items: center;
  justify-content: space-between;
`;
